import React from "react";
//
import { FlexDiv } from "@/components/Atoms/Box";
import ImageBox from "@/components/Molecules/ImageBox";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";
//
import { Container, TextBox, Wrapper, Subtitle } from "./style";
//
function PartnerBanner({
  partnerSrc,
  locoSubtext,
  title,
  subtitle,
  width,
  logoSize,
}) {
  return (
    <Wrapper>
      <Container>
        <FlexDiv
          p={width <= 992 ? "8px 0" : "8px 18px"}
          mr={width <= 992 ? "0px" : "16px"}
          mb={width <= 992 ? "16px" : "0px"}
          width={width <= 992 ? "unset" : "296px"}
          flexDirection="column"
        >
          {partnerSrc && (
            <ImageBox
              src={partnerSrc}
              maxWidth={
                width <= 767 ? logoSize?.maxMobileWidth : logoSize?.maxWidth
              }
              maxHeight={
                width <= 767 ? logoSize?.maxMobileHeight : logoSize?.maxHeight
              }
              fill={theme.colors.black}
              m={`0 auto ${locoSubtext ? "8px" : "0px"} ${
                width <= 992 ? "11px" : "auto"
              }`}
              objectFit="contain"
            />
          )}
          {locoSubtext && (
            <Typography
              variant="heading5"
              isExtraBold
              color={theme.colorsV2.gray.shade_800}
              px={width <= 992 ? "24px" : ""}
            >
              {locoSubtext}
            </Typography>
          )}
        </FlexDiv>
        <TextBox>
          {title && (
            <Typography
              variant="heading4"
              mb="8px"
              color={theme.colorsV2.gray.shade_800}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {subtitle && (
            <Subtitle
              variant="heading6"
              color={theme.colorsV2.gray.shade_800}
              maxWidth="760px"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          )}
        </TextBox>
      </Container>
    </Wrapper>
  );
}

export default PartnerBanner;
